import React, { Suspense, lazy } from 'react';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { ThemeProvider } from './context/ThemeContext';
import './App.css';

// Lazy load components for performance optimization
const Header = lazy(() => import('./components/Header'));
const About = lazy(() => import('./components/About'));
const Courses = lazy(() => import('./components/Courses'));
const Skills = lazy(() => import('./components/Skills'));
const Experience = lazy(() => import('./components/Experience'));

// Loading fallback
const LoadingFallback = () => (
  <div className="loading-spinner">
    <div className="spinner"></div>
  </div>
);

function App() {
  return (
    <ThemeProvider>
      <HelmetProvider>
        <div className="app">
          <Helmet>
            <title>Sean Wheeler | Stanford University</title>
            <meta name="description" content="Personal website of Sean Wheeler, an Adjunct Lecturer and former DCI fellow at Stanford University." />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            
            {/* Schema.org structured data */}
            <script type="application/ld+json">
              {`
                {
                  "@context": "http://schema.org",
                  "@type": "Person",
                  "name": "Sean Wheeler",
                  "jobTitle": "Adjunct Lecturer",
                  "url": "https://web.stanford.edu/~seanwhe75/",
                  "sameAs": [
                    "https://www.linkedin.com/in/sean-wheeler-61074115/"
                  ],
                  "alumniOf": {
                    "@type": "CollegeOrUniversity",
                    "name": "Stanford University"
                  },
                  "knowsAbout": ["Startups", "Consulting", "Advisory", "Design Thinking", "Service Design"],
                }
              `}
            </script>
          </Helmet>
          
          <Suspense fallback={<LoadingFallback />}>
            <Header />
            <main>
              <About />
              <Courses />
              <Skills />
              <Experience />
            </main>
          </Suspense>
        </div>
      </HelmetProvider>
    </ThemeProvider>
  );
}

export default App;